import React from 'react';
import { Card, TransactionTableRow, TransactionHeader, TransactionTable, TransactionTableBody, TransactionTableHeader, TransactionData, TransactionTableButton } from './AccountElements';
import { FaEllipsisH } from 'react-icons/fa';
const TransactionsOverview = ({ transactions, handleReturnProcess }) => {

    return (
        <Card>
            <TransactionTable>
                <TransactionTableHeader>
                    <TransactionTableRow>
                        <TransactionHeader>Amount</TransactionHeader>
                        <TransactionHeader>Status</TransactionHeader>
                        {/* <TransactionHeader>Transaction ID</TransactionHeader> */}
                        <TransactionHeader>Product Type</TransactionHeader>
                        {/* <TransactionHeader>Date</TransactionHeader> */}
                        <TransactionHeader>Actions</TransactionHeader>
                    </TransactionTableRow>
                </TransactionTableHeader>
                <TransactionTableBody>
                    {transactions.length > 0 &&
                        transactions.map((transaction, index) => (
                            <TransactionTableRow key={index} className="transaction-item">
                                <TransactionData>{(transaction.amount / 100.0).toLocaleString("en-US", { style: "currency", currency: "USD" })}</TransactionData>
                                <TransactionData>
                                    <TransactionTableButton
                                        disabled={true}
                                        status={'succeeded'}
                                    >
                                        Succeeded
                                    </TransactionTableButton>
                                </TransactionData>
                                {/* <TransactionData variableText={true}>{transaction.description}</TransactionData> */}
                                <TransactionData>
                                    {transaction.amount === "400" ? 'Digital Book' : 'Subscription'}
                                </TransactionData>
                                {/* <TransactionData>{transaction.date}</TransactionData> */}
                                <TransactionData>
                                    {transaction.refunded ? (
                                        <TransactionTableButton
                                            disabled={true}
                                            status={'succeeded'}
                                        >
                                            Refunded
                                        </TransactionTableButton>
                                    ) :
                                        <TransactionTableButton disabled={transaction.refunded} onClick={(e) => handleReturnProcess(e, transaction.description, transaction.paymentIntentID)}>
                                            <FaEllipsisH />
                                        </TransactionTableButton>
                                    }
                                </TransactionData>
                            </TransactionTableRow>
                        ))}
                </TransactionTableBody>

            </TransactionTable>
        </Card>
    );
};

export default TransactionsOverview;
